import React, { useRef, useState } from 'react';
import { TableInput } from '../../../../components/common';
import { handleChangeModuleData } from '../../helpers/handleChangeModuleData';
import { MenuItem } from '@mui/material';
import CustomSelect from '../../../../components/common/SelectField';
import Add from '@mui/icons-material/Add';
import { useAuth } from '../../../../services/auth/AuthProvider';
import { getDaysArr } from '../../helpers/utils';
import { useQuery } from '../../../../hooks/UseQuery';
import { DeleteIconButton } from '../../../../components/common/button/CustomIconButton';

interface IProps {
  moduleData: any;
  isView: boolean;
  oneListObj: any;
  index: number;
  handelDeleteRows: any;
  department: string;
}
const TBodyRow = ({
  isView,
  oneListObj,
  index,
  handelDeleteRows,
  department,
}: IProps) => {
  const [render, setRender] = useState(false);
  const { state } = useAuth();
  const annual_month = useQuery('annual_date') || '';
  const dayArr = getDaysArr(annual_month);
  const varColSpan = dayArr?.length || 31;

  const capitalizeWords = (str: string) => {
    return str
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };
  // const [sr, setSr] = useState(0);
  const show = () => {
    const tr =
      !oneListObj?.leave &&
      (department === '' || oneListObj?.a4 === department);

    return tr;
  };

  return (
    <React.Fragment key={index + 10.1 + 'heading '}>
      {show() && (
        <tr>
          <th style={{ minWidth: '50px', textAlign: 'center' }}>{index + 1}</th>
          <td style={{ minWidth: '200px', textAlign: 'center' }}>
            {capitalizeWords(oneListObj?.a1)}
          </td>
          <td style={{ minWidth: '200px', textAlign: 'center' }}>
            {oneListObj?.a2}
          </td>
          <td style={{ minWidth: '200px', textAlign: 'center' }}>
            {oneListObj?.a3.toUpperCase()}
          </td>
          <td style={{ minWidth: '200px', textAlign: 'center' }}>
            {oneListObj?.a4?.toUpperCase()}
          </td>

          {Array.from({ length: varColSpan }, (_, indx) => (
            <td
              style={{
                minWidth: '100px',
                textAlign: 'center',
                fontSize: '2rem',
                ...(oneListObj.attendance[indx] === 'H' && {
                  background: '#ffec99',
                }),
                ...(oneListObj.attendance[indx] === 'S' && {
                  background: '#b2f2bb',
                }),
                ...(oneListObj.attendance[indx] === 'L' && {
                  background: '#eebefa',
                }),
              }}
              key={index + 2.2 + indx + 'after' + 111.33}
            >
              {isView ||
              oneListObj.attendance[indx] === 'S' ||
              oneListObj.attendance[indx] === 'H' ? (
                oneListObj.attendance[indx]
              ) : (
                <CustomSelect
                  name="attendance[indx]"
                  value={oneListObj?.attendance[indx]}
                  onChange={(e) => {
                    oneListObj.attendance[indx] = e.target.value;
                    setRender((prev) => !prev);
                  }}
                  disabled={oneListObj?.attendance[indx] === 'S'}
                >
                  <MenuItem value="">None</MenuItem>
                  <MenuItem value="P">P</MenuItem>
                  <MenuItem value="A">A</MenuItem>
                  <MenuItem value="L">L</MenuItem>
                </CustomSelect>
              )}
            </td>
          ))}
          <td
            style={{ minWidth: '100px', textAlign: 'center' }}
            colSpan={isView ? 2 : 1}
          >
            <TableInput
              isView={isView}
              name="remarks"
              type="text"
              value={oneListObj.remarks}
              onChange={(e) => {
                handleChangeModuleData(e, oneListObj);
                setRender((prev) => !prev);
              }}
            />
          </td>
          {!isView && (
            <td style={{ minWidth: '100px' }}>
              <DeleteIconButton
                tooltipTitle={'delete'}
                onClick={() => {
                  handelDeleteRows();

                  oneListObj.leave = true;
                }}
              />
            </td>
          )}
        </tr>
      )}
    </React.Fragment>
  );
};

export default TBodyRow;
